@import '../../scss/mixin';

.main {
  --u: 1cqw;
  --rem: 16px;
  --margin: #{clampUnit(20, 110)};
  --negative-margin: calc(var(--margin) * -1);
  --gap: #{clampUnit(16, 32)};

  container-type: inline-size;
  position: relative;
  display: flex;
  justify-content: center;
  pointer-events: none;
  width: 100%;
  background: transparent;
  color: var(--llm-main-foreground);
}
